import Card from "../../card/Card";
import SoulStone from "../../../images/main_menu/soul_stone.png";
import DivineEssence from "../../../images/main_menu/divine_essence.png";
import React from "react";
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import parse from "html-react-parser";

function OpenCard({openCard}: any) {
    const {user} = useTypedSelector(state => state.auth);
    let word = 'First';

    switch (openCard.number_in_library) {
        case 1:
            word = 'First';
            break;
        case 2:
            word = 'Second'
            break;
        case 3:
            word = 'Third';
            break;
        case 4:
            word = 'Fourth';
            break;
        case 5:
            word = 'Fifth';
            break;
        default:
            word = openCard.number_in_library;
    }
    let maxNum = 5;
    if(openCard.card.id === 1042 || openCard.card.id === 1043 || openCard.card.id === 1044) {
        maxNum = 10;
    }

    const num = openCard.number_in_library + '/' + maxNum;

    let textNum = word + ' in Library <br />' + num;

    if (openCard.cashback !== false) {
        textNum = 'Full set ' + num;
    }

    const cashbackMap: Record<number, number> = {
        10: 20,
        25: 50,
        50: 100,
        2: 4
    };


    const isDivine = openCard.card.level === 4;

    return (
        <div className={'openCardContainer'}>
            <div className={'openCardLibraryNum'}>
                <div className={'openCardNumIn Lib'}>{parse(textNum)}</div>

                {openCard.cashback !== false && (
                    <>
                        <div className={'openCardCash'}>
                            {openCard.cashback}
                            <img
                                className='openCardSoulStone'
                                src={(isDivine ? DivineEssence : SoulStone) as any}
                                alt={isDivine ? 'Divine Essence' : 'Soul Stone'}
                            />
                            {" "}added
                        </div>

                        {!user.premium && (
                            <div className="openCardPromo">
                                ({cashbackMap[openCard.cashback]} with Season Pass)
                            </div>
                        )}
                    </>
                )}
            </div>

            <Card card={openCard.card}/>
        </div>
    );
}

export default OpenCard;